/* eslint-disable no-debugger */
import { getAuthDeferred } from '../utils/firebase';
import { WORKERS } from './config';
import { client } from './generated/client.gen';

const { USERS_WORKER } = WORKERS;

// Initialize the client with base URL
client.setConfig({
  baseURL: USERS_WORKER,
  throwOnError: false,
});

// Set up Firebase auth token interceptor
const auth = getAuthDeferred();

// Add request interceptor to include auth token on each request
client.instance.interceptors.request.use(async (config) => {
  const currentUser = auth.currentUser;
  if (currentUser) {
    const token = await currentUser.getIdToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// Export the configured client
export { client };

// Export all the generated types and SDK functions
export * from './generated';

// Export TanStack Query hooks for convenience
export * from './generated/@tanstack/react-query.gen';
